import { render } from "./QuizFavoris.vue?vue&type=template&id=0448a9d3&scoped=true"
import script from "./QuizFavoris.vue?vue&type=script&lang=js"
export * from "./QuizFavoris.vue?vue&type=script&lang=js"

import "./QuizFavoris.vue?vue&type=style&index=0&id=0448a9d3&scoped=true&lang=css"

import exportComponent from "C:\\projets\\salon-metiers-2026\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0448a9d3"]])

export default __exports__